import "./about.css";
import resume from "../../resume/resume.pdf";
import React from "react";
import insta from "../../img/insta.png";
import github from "../../img/github.png";
import linkedIN from "../../img/linkedIN.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="https://www.kindpng.com/picc/m/112-1127696_software-developer-hd-png-download.png"
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
          I am a Full stack Web Developer with decent knowledge of the Tech
          Stacks in this domain. Highly Interested in Competitive Coding as
          well.
        </p>
        <p className="a-desc">
          I have developed ample amount of skills in Development and Competitive
          Coding starting from scratch. Apart from all the techy-geeky things, I
          like to play Guitar. I am also interested in Video Editing. I also
          play football.
        </p>
        <p>Find me on my socials! Given Below.</p>
        <div className="wrap">
          <div className="ll">
            <a
              href="https://www.instagram.com/jay_._24/"
              target="_blank"
              rel="noreferrer"
            >
              <img className="socials" src={insta} alt="" />
            </a>
            <a
              href="https://github.com/Jedi-24"
              target="_blank"
              rel="noreferrer"
            >
              <img className="socials" src={github} alt="" />
            </a>
            <a
              href="https://www.linkedin.com/in/jay-aggarwal-87b288208/"
              target="_blank"
              rel="noreferrer"
            >
              <img className="socials" src={linkedIN} alt="" />
            </a>
          </div>
          <div className="rr">
            <button>
              <a href={resume} download="RESUME">
                DOWNLOAD RESUME
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
